import BigNumber from "bignumber.js";
import { BASE18 } from "src/configs/constance";
import { handleEmit } from "src/contract-logic/logic";
import { getCurrentContractAddresses } from "src/configs/address";
import ABI from "src/contract-logic/abis/NFTTicketStakingABI.json";
import { getWeb3Sender, web3Reader } from "src/wallet-connection";

const { NFT_TICKET_STAKING } = getCurrentContractAddresses();
var contractReader = null;
var contractSender = null;

function getContractReader() {
  if (!contractReader) {
    contractReader = new web3Reader.eth.Contract(ABI, NFT_TICKET_STAKING);
  }
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) {
    contractSender = new web3Sender.eth.Contract(ABI, NFT_TICKET_STAKING);
  }
  return contractSender;
}

const getTotalTicketStaking = async () => {
  const res = await getContractReader().methods.totalTicketStaking().call();
  return parseInt(res);
};

const getUserStakingTotal = async (address) => {
  const res = await getContractReader().methods.getUserStakingTotal(address).call();
  return parseInt(res);
};

const getUnlockTime = async () => {
  const res = await getContractReader().methods.getUnlockTime().call();
  return parseInt(res);
};
const getStakingTime = async () => {
  const res = await getContractReader().methods.getStakingTime().call();
  return parseInt(res);
};

const getTotalUserReward = async (address) => {
  const res = await getContractReader().methods.getUserTotalReward(address).call({ from: address });
  return BigNumber(res).dividedBy(BASE18).toNumber();
};

async function stakingTicket(dispatch, amount, accountAddress) {
  const emit = getContractSender().methods.stakingTicket(amount).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Staking");

  const res = await emit;
  if (res.events.Staked) {
    return {
      status: "success",
    };
  } else {
    throw new Error("Event not found");
  }
}

async function claimAll(dispatch, accountAddress) {
  const emit = getContractSender().methods.claimAll().send({ from: accountAddress });
  handleEmit(dispatch, emit, "Claim Reward");
  await emit;
}

async function isApprovedForAll(ownerAddress, operatorAddress, accountAddress) {
  return await getContractReader()
    .methods.isApprovedForAll(ownerAddress, operatorAddress)
    .call({ from: accountAddress });
}

async function approveForAll(dispatch, operatorAddress, accountAddress) {
  const emit = getContractSender().methods.setApprovalForAll(operatorAddress, true).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Approve");
  await emit;
}

export default {
  ABI,
  ADDRESS: NFT_TICKET_STAKING,
  getTotalTicketStaking,
  claimAll,
  getUserStakingTotal,
  stakingTicket,
  getStakingTime,
  getUnlockTime,
  isApprovedForAll,
  approveForAll,
  getTotalUserReward,
};
